import type { QueryClient } from "@tanstack/react-query";
import {
  type LinkComponentProps,
  isMatch,
  useMatches,
  useRouter,
} from "@tanstack/react-router";
import type { ReactNode } from "react";
import { trpc } from "~/lib/trpc";

type CrumbOption =
  | ({
      type: "nav";
      label: string;
    } & LinkComponentProps)
  | {
      type: "action";
      label: ReactNode;
      dialog: "add_page";
    };

export type Crumb = {
  label: ReactNode;
  id: string;
  options: Array<CrumbOption>;
};

export function useBreadcrumbs() {
  // Get all matching routes in the path hierarchy
  // This will let us access loaderData from every LAYOUT route in the hiearchy, and the current page
  const matches = useMatches();
  return matches
    .filter((match) => isMatch(match, "loaderData.crumb"))
    .map(({ pathname, loaderData }) => ({
      to: pathname,
      label: loaderData!.crumb.label,
      id: loaderData!.crumb.id ?? loaderData!.crumb.label,
      options: loaderData!.crumb.options,
    })) as Array<Crumb & { to: string }>;
}

export function invalidateBreadcrumbs(
  queryClient: QueryClient,
  router: ReturnType<typeof useRouter>,
) {
  queryClient.removeQueries({
    queryKey: trpc.pages.getPageCrumbOptions.queryKey(),
  });

  router.invalidate({
    filter: (match) => match.fullPath === "/pages/$pageId",
  });
}
